<template>
<div>
	<template v-for="item in items">
		<v-layout
			v-if="item.heading"
			:key="item.heading"
			row
			align-center
		>
			<v-flex xs12>
				<v-subheader v-if="item.heading">
					{{ item.heading }}
				</v-subheader>
			</v-flex>
		</v-layout>
		<v-list-group
			v-else-if="item.children"
			v-model="item.model"
			:key="item.text"
			:prepend-icon="item.model ? item.icon : item['icon-alt']"
			append-icon=""
		>
			<v-list-tile>
				<v-list-tile-content>
					<v-list-tile-title>
						{{ item.text }}
					</v-list-tile-title>
				</v-list-tile-content>
			</v-list-tile>
			<v-list-tile
				v-for="(child, i) in item.children"
				:key="i"
				@click=""
			>
				<v-list-tile-action v-if="child.icon">
					<v-icon>{{ child.icon }}</v-icon>
				</v-list-tile-action>
				<v-list-tile-content>
					<v-list-tile-title>
						{{ child.text }}
					</v-list-tile-title>
				</v-list-tile-content>
			</v-list-tile>
		</v-list-group>
		<v-list-tile v-else :key="item.token_id"
		@dragenter.prevent="dragEnter" @dragleave.prevent="dragLeave"
		@dragover.prevent="dragOver" @drop.prevent="drop($event, item.token_id)"
		>
			<v-list-tile-action>
				<v-checkbox
				:value="item.visible"
				@click.prevent.stop="setVisible(item.token_id, !item.visible)"
				></v-checkbox>
			</v-list-tile-action>
			<v-list-tile-content>
				<v-list-tile-title>
					{{ item.text || item.token_id }}
				</v-list-tile-title>
				<v-list-tile-sub-title>
					<v-avatar size="8" :color="item.color" class="mr-1"></v-avatar>
					<span v-if="!item.recording && !item.uploading">{{ item.token_id }}</span>
					<span v-if="item.recording" class="red--text">Recording</span>
					<span v-if="item.uploading" class="teal--text">
						Uploading <v-progress-circular :size="10" :width="1" indeterminate/>
					</span>
				</v-list-tile-sub-title>
			</v-list-tile-content>

			<v-list-tile-action v-if="item.shared_by">
				<v-menu offset-y>
					<v-icon slot="activator" color="teal" small>fa-share-alt</v-icon>
					<v-list dense>
						<v-list-tile>
							<v-list-tile-content>
								<div>
									Shared by <b>{{item.shared_by}}</b>
								</div>
							</v-list-tile-content>
						</v-list-tile>
					</v-list>
				</v-menu>
			</v-list-tile-action>

			
			<v-list-tile-action>
				<v-btn flat icon title="Options" @click.native.stop="(ev) => showOptionsMenu(ev, item.token_id)">
					<v-icon small>fa-ellipsis-h</v-icon>
				</v-btn>
			</v-list-tile-action>
		</v-list-tile>
	</template>
		<v-card v-if="!items.length">
			<v-card-text>
				No channels currently visible.
				<span v-if="!isLoggedIn">Please register or log in to create channels.</span>
			</v-card-text>
			<v-card-actions>
				<v-btn small flat @click="moreInfo = !moreInfo"><small>More info…</small> <v-icon small right>fa-question-circle</v-icon></v-btn>
			</v-card-actions>
			<v-slide-y-transition>
				<v-card-text v-show="moreInfo">
					<b>Channels</b> are where you save tracking data. You can save data from one or more sources on the same channel. Channels can also be shared with other users.
				</v-card-text>
			</v-slide-y-transition>
		</v-card>
	
	<follow-token-list-menu
	:show="menu.visible" v-on:hide="menu.visible=false"
	:activator="menu.activator"
	:token_id="menu.token_id"
	></follow-token-list-menu>
</div>
</template>

<style lang="stylus" scoped>
>>>
	.over
		border 2px dashed #000
</style>

<script>
import Vuex from 'vuex'

import FollowTokenListMenu from './TokenListMenu'
import api from '../../assets/js/api-instance'


export default {
	name: "FollowTokenList",
	
	components: {
		FollowTokenListMenu
	},
	
	data () {
		return {
			menu: {
				visible: false,
				activator: null,
				token_id: null
			},
			moreInfo: false,
			dropTarget: null
		};
	},
	
	watch: {
		visibleTokens () {
			this.$router.push({
				name: 'tokens',
				params: {
					token_ids: this.visibleTokens.join(';') || null
				}
			});
		},
		
		dropTarget (newTarget, oldTarget) {
			if (newTarget != oldTarget) {
				if (oldTarget) {
					oldTarget.classList.remove("over");
				}
				if (newTarget) {
					newTarget.classList.add("over");
					console.log("→", newTarget.dataset.tokenid);
				}
			}
		}
	},
	
	computed: {
		...Vuex.mapState(["userData", "tokenData"]),
		...Vuex.mapGetters(["visibleTokens"]),
		
		items () {
			return this.tokenData.tokens
			.filter( token => // Do not show own publicly shared tokens
				!(token.shared_by == this.userData.handle && token.user_id == "00000000" ))
			.map( token => {
				const tokenState = this.tokenData.tokenState[token.token_id];
				return {
					token_id: token.token_id,
					shared_by: token.shared_by,
					icon: "fa-globe-africa",
					color: token.metadata.style && token.metadata.style.color,
					text: token.metadata.name,
					path: `/tokens/${token.token_id}/`,
					visible: tokenState && tokenState.visible || false,
					recording: tokenState && tokenState.recording || false,
					uploading: tokenState && tokenState.uploading || false
				}
			});
		},
		
		isLoggedIn () {
			return !!this.userData.user_id;
		}
	},
	
	methods: {
		...Vuex.mapActions(["setTokenVisible"]),
		
		async setVisible (token_id, visible) {
			const zoomIn = !this.visibleTokens.length
			
			await this.setTokenVisible({token_id, visible});
			
			console.log("ZIN", zoomIn);
			if (zoomIn) {
				console.log("ZOOM", token_id);
				this.$root.$emit('zoom', {token_id: token_id});
			}
		},

		showOptionsMenu (event, token_id) {
			this.menu.activator = event.target;
			this.menu.token_id = token_id;
			this.menu.visible = true;
		},
		
		validDropCandidate (file) {
			const acceptedMIME = [
				"application/geo+json",
				"application/vnd.geo+json" // Because Microsoft ☹
			];
			
			return acceptedMIME.includes(file.type) ||
				(!file.type && /^.*\.geojson$/i.test(file.name)); // Because Microsoft ☹
		},
		
		dragEnter (ev) {
			const files = Array.from(ev.dataTransfer.items).filter(this.validDropCandidate);
			if (files.length) {
				ev.preventDefault();
				this.dropTarget = ev.currentTarget;
			}
		},
		
		dragLeave (ev) {
			ev.preventDefault();
		},
		
		dragOver (ev) {
			ev.preventDefault();
			ev.dataTransfer.dropEffect = "copy";
		},
		
		drop (ev, token_id) {
			console.log("drop");
			const files = Array.from(ev.dataTransfer.files).filter(this.validDropCandidate);
			
			if (files.length) {
				ev.preventDefault();
				//console.log("Uploading", files.map(f => f.name), "to", token_id);
				this.uploadGeoJSON(token_id, files);
			}
			this.dropTarget = null;
		},
		
		async uploadGeoJSON (token_id, files) {
			const url = "/token/"+encodeURIComponent(token_id)+"/fixes.json";
			this.$store.commit('setTokenAttributes', { [token_id]: { uploading: true } });
			
			for (const file of files) {
				try {
					await api.uploadFixes(token_id, file);
				} catch (err) {
					this.$root.$emit('error', err.message);
				}
			}
			
			this.$store.commit('setTokenAttributes', { [token_id]: { uploading: false } });
		}
	}

}
</script>
